import { ComponentProps } from 'react'
import * as Components from '../components'
import * as Stores from '../stores'
import { useLegacyCard } from '@/src/common/hooks/useCardInformation'
import { NetworkStatus } from '@apollo/client'

export function useProgressChecklistPlatform() {
  const { data: awardQueryResult } = Stores.MortgageEarnApi.endpoints[
    'GET /mortgage/earn'
  ].useQuery({}, { refetchOnMountOrArgChange: true })
  // TODO: We only care about the start date so once that is included
  //       in the card account REST payload, we can migrate over
  const cardQuery = useLegacyCard()

  if (!awardQueryResult || cardQuery.networkStatus === NetworkStatus.loading) return 'loading'

  const { latestMonthlyAward, activeMonthlyAward } = awardQueryResult
  const { awardAmountInPoints: latestAwardAmount } = latestMonthlyAward
  const { awardAmountInPoints: activeAwardAmount } = activeMonthlyAward ?? {}
  const isProgramEnrolled = Boolean(activeAwardAmount || latestAwardAmount)

  const cardInformation = cardQuery.data?.getCreditCardInformation.node
  const statementPeriodStart = cardInformation?.financialAccount.statementPeriodStart
  const periodStart = statementPeriodStart ? new Date(statementPeriodStart) : undefined

  return {
    periodStart,
    periodEnd: awardQueryResult.progress.statementCloseDate,
    isEnrolled: isProgramEnrolled,
    statementSpend: awardQueryResult.progress.statementSpend,
    statementSpendRemaining: awardQueryResult.progress.statementSpendRemaining,
  } as const satisfies ComponentProps<typeof Components.ProgressChecklistItem>
}
